import EN from '../lang/en-us';
import ZH from '../lang/zh-cn';

let I18N = EN;
const lang = (navigator.language || navigator.browserLanguage).toLowerCase();
if (lang.indexOf('cn') !== -1) {
	I18N = ZH;
}

function getPlainData(langStore, path) {
	let data = langStore;
	const pathArr = path.split('.');
	return pathArr.reduce((pre, key) => {
		if (pre[key])
		{
			return pre[key];
		}
		else
		{
			return pre;
		}
	}, data);
}

function useI18n(path) {
	return getPlainData(I18N, path);
}

export default useI18n;
